import { render, staticRenderFns } from "./CouponCode.vue?vue&type=template&id=4b13a9b6&scoped=true&"
import script from "./CouponCode.vue?vue&type=script&lang=js&"
export * from "./CouponCode.vue?vue&type=script&lang=js&"
import style0 from "./CouponCode.vue?vue&type=style&index=0&id=4b13a9b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13a9b6",
  null
  
)

export default component.exports